import { render, staticRenderFns } from "./parallax-section.vue?vue&type=template&id=ff1b2fc2&scoped=true&"
import script from "./parallax-section.vue?vue&type=script&lang=js&"
export * from "./parallax-section.vue?vue&type=script&lang=js&"
import style0 from "./parallax-section.vue?vue&type=style&index=0&id=ff1b2fc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1b2fc2",
  null
  
)

export default component.exports